import { render } from "./ContentCustomizingPurchaseCountDeclare.vue?vue&type=template&id=c9ea4454&ts=true"
import script from "./ContentCustomizingPurchaseCountDeclare.vue?vue&type=script&lang=ts"
export * from "./ContentCustomizingPurchaseCountDeclare.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__